module.exports = __webpack_public_path__ + "media/images/flags/32/Costa-Rica-2a75ab20cd3fe2a2a7b00e12cef98851.png";